import { useGetMe } from './queries/me/use-get-me'

export const defaultDateFormat = 'eu'

const euNumeric = 'dd-MM-yyyy'
const usNumeric = 'MM-dd-yyyy'

const euNumericNoYear = 'dd-MM'
const usNumericNoYear = 'MM-dd'

const euLiteral = 'dd MMM, yyyy'
const usLiteral = 'MMM dd, yyyy'

const euLiteralNoYear = 'dd MMM'
const usLiteralNoYear = 'MMM dd'

const euLiteralFull = 'dd MMMM yyyy'
const usLiteralFull = 'MMMM dd yyyy'

const euLiteralMonthAndYear = 'MMMM yyyy'
const usLiteralMonthAndYear = 'MMMM yyyy'

const euNumericShort = 'dd-MM-yy'
const usNumericShort = 'MM-dd-yy'

const euWithHoursNoMinutes = 'dd-MM-yyyy, HH:00'
const usWithHoursNoMinutes = 'MM-dd-yyyy, HH:00'

const euWithHoursAndMinutes = 'dd-MM-yyyy, HH:mm'
const usWithHoursAndMinutes = 'MM-dd-yyyy, HH:mm'

const euDatePickerFormat = 'dd/MM/yyyy'
const usDatePickerFormat = 'MM/dd/yyyy'

export function useDateFormat(
  variant:
    | 'date-picker'
    | 'with hours'
    | 'with hours and minutes'
    | 'literal'
    | 'literal - full'
    | 'literal - month and year'
    | 'literal - no year'
    | 'numeric - no year'
    | 'numeric - short'
    | 'numeric' = 'numeric',
) {
  const { data: me } = useGetMe()
  const localization = me?.settings?.dateFormat || defaultDateFormat
  if (localization === 'eu') {
    if (variant === 'date-picker') return euDatePickerFormat
    if (variant === 'with hours') return euWithHoursNoMinutes
    if (variant === 'with hours and minutes') return euWithHoursAndMinutes
    if (variant === 'literal') return euLiteral
    if (variant === 'literal - no year') return euLiteralNoYear
    if (variant === 'literal - full') return euLiteralFull
    if (variant === 'literal - month and year') return euLiteralMonthAndYear
    if (variant === 'numeric - no year') return euNumericNoYear
    if (variant === 'numeric - short') return euNumericShort
    return euNumeric
  } else {
    if (variant === 'date-picker') return usDatePickerFormat
    if (variant === 'with hours') return usWithHoursNoMinutes
    if (variant === 'with hours and minutes') return usWithHoursAndMinutes
    if (variant === 'literal') return usLiteral
    if (variant === 'literal - no year') return usLiteralNoYear
    if (variant === 'literal - full') return usLiteralFull
    if (variant === 'literal - month and year') return usLiteralMonthAndYear
    if (variant === 'numeric - no year') return usNumericNoYear
    if (variant === 'numeric - short') return usNumericShort
    return usNumeric
  }
}
